/* 🤖 this file was generated by svg-to-ts */
export const matIconViewCarousel: {
  name: 'view-carousel';
  data: string;
} = {
  name: 'view-carousel',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 7h4v10H2V7zm5 12h10V5H7v14zM9 7h6v10H9V7zm9 0h4v10h-4V7z"/></svg>`
};
